__turbopack_context__.v({
  "wrapper": "cardListItem-module-scss-module__x7Ct_G__wrapper",
});
